var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckerOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.8 158",
    style: {
      enableBackground: "new 0 0 157.8 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4EC6E1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3030.49,-2214.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3166.7,2214.7h-114.6c-11.9,0-21.6,9.7-21.6,21.6v114.6c0,11.9,9.7,21.6,21.6,21.6h114.6 c11.9,0,21.6-9.7,21.6-21.6v-114.6C3188.3,2224.4,3178.7,2214.7,3166.7,2214.7z M3098.4,2312.7l62.9-62.9c3.4-3.4,8.9-3.4,12.3,0 l0,0c3.4,3.4,3.4,8.9,0,12.3l-75.2,75.2c-3.4,3.4-8.9,3.4-12.3,0l-40.9-40.9c-3.4-3.4-3.4-8.9,0-12.3l0,0c3.4-3.4,8.9-3.4,12.3,0 l28.6,28.6C3089.5,2316.1,3095,2316.1,3098.4,2312.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckerOn);
export default __webpack_public_path__ + "static/media/checker-on.9170499e57887f8f83fbb8cdd561c333.svg";
export { ForwardRef as ReactComponent };